import { closeSnackbar, enqueueSnackbar } from "notistack";
import { isValidArray } from "../Layout/Common/common";

const defaultDuration = 5000;
const anchorPosition = { vertical: "bottom", horizontal: "center" };

// Helper function to create action buttons
const createActionButton = (key, actionsList) => {
  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      {isValidArray(actionsList)
        ? actionsList.map((action, index) => (
            <button
              key={index}
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid white",
                color: "white",
                cursor: "pointer",
                padding: "4px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                marginRight: "4px",
              }}
              onClick={() => {
                action.callback();
                closeSnackbar(key);
              }}
            >
              {action.label}
            </button>
          ))
        : actionsList != null && (
            <button
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid white",
                color: "white",
                cursor: "pointer",
                padding: "4px 12px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
              onClick={() => {
                actionsList.callback();
                closeSnackbar(key);
              }}
            >
              {actionsList.label}
            </button>
          )}
      <button
        style={{
          background: "none",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontSize: "18px",
          padding: "4px 8px",
        }}
        onClick={() => closeSnackbar(key)}
      >
        ×
      </button>
    </div>
  );
};

/**
 * Show info snackbar
 * @param {string} message - The message to display
 * @param {object|array} actions - Single action {label, callback} or array of actions
 * @param {number} duration - Auto hide duration in milliseconds (default: 5000)
 */
export const showInfoSnackbar = (message, actions = null, duration = defaultDuration) => {
  const config = {
    variant: "info",
    anchorOrigin: anchorPosition,
    autoHideDuration: duration,
  };

  config.action = (key) => createActionButton(key, actions);
  enqueueSnackbar(message, config);
};

/**
 * Show error snackbar
 * @param {string} message - The message to display
 * @param {object|array} actions - Single action {label, callback} or array of actions
 * @param {number} duration - Auto hide duration in milliseconds (default: 5000)
 */
export const showErrorSnackbar = (message, actions = null, duration = defaultDuration) => {
  const config = {
    variant: "error",
    anchorOrigin: anchorPosition,
    autoHideDuration: duration,
  };

  config.action = (key) => createActionButton(key, actions);

  enqueueSnackbar(message, config);
};

/**
 * Show success snackbar
 * @param {string} message - The message to display
 * @param {object|array} actions - Single action {label, callback} or array of actions
 * @param {number} duration - Auto hide duration in milliseconds (default: 5000)
 */
export const showSuccessSnackbar = (message, actions = null, duration = defaultDuration) => {
  const config = {
    variant: "success",
    anchorOrigin: anchorPosition,
    autoHideDuration: duration,
  };

  config.action = (key) => createActionButton(key, actions);

  enqueueSnackbar(message, config);
};

/**
 * Show warning snackbar
 * @param {string} message - The message to display
 * @param {object|array} actions - Single action {label, callback} or array of actions
 * @param {number} duration - Auto hide duration in milliseconds (default: 5000)
 */
export const showWarningSnackbar = (message, actions = null, duration = defaultDuration) => {
  const config = {
    variant: "warning",
    anchorOrigin: anchorPosition,
    autoHideDuration: duration,
    style: { zIndex: 1155 },
  };
  config.action = (key) => createActionButton(key, actions);

  enqueueSnackbar(message, config);
};
